
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface CalculatorCardProps {
  title: string;
  description: string;
  icon: string;
  path: string;
  available: boolean;
}

const CalculatorCard = ({ title, description, icon, path, available }: CalculatorCardProps) => {
  return (
    <Card className={`${available ? '' : 'opacity-60'} border-0 shadow-none`}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span className="text-2xl">{icon}</span>
          <span>{title}</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <CardDescription>{description}</CardDescription>
        {available ? (
          <Link 
            to={path}
            className="font-bold mt-4 inline-block text-sm text-primary hover:underline"
          >
            Open Calculator
          </Link>
        ) : (
          <p className="mt-4 text-sm text-muted-foreground">Coming Soon</p>
        )}
      </CardContent>
    </Card>
  );
};

export default CalculatorCard;
